import axios from "axios";
import { getFromLocalStorage } from "./storageUtil";

const token = getFromLocalStorage("admin")
  ? getFromLocalStorage("admin")?.accessToken
  : null;

const axiosInstance = axios.create({
  baseURL: "https://admin.beautyspotapp.co.uk/api",
  // baseURL: "https://beautyspot.codingcopz.in/api",
  headers: {
    Authorization: `Bearer ${token}`
  }
});

axiosInstance.interceptors.response.use(
  (response) => {
    // if (response?.data?.message === 'jwt malformed') {
    //   localStorage.clear();
    //   window.location.href = "/auth/login";
    // }
    return response;
  },
  (error) => {
    // Pass the error along to be handled elsewhere
    return Promise.reject(error);
  }
);

export const imgPath = "https://beautyspot-prod.s3.amazonaws.com/prod/";

export default axiosInstance;
